function getRecordFromIncluded(data, included, depth) {
  if (data === null) {
    return;
  }

  const fullData = included.find((i) => i.uuid === data.uuid && i.type === data.type) || data;
  return dejsonapinize(fullData, included, depth);
}

export default function dejsonapinize(data, included = [], depth = 0) {
  if (Array.isArray(data)) {
    return data.map((d) => dejsonapinize(d, included, depth));
  } else {
    data = {
      uuid: undefined,
      type: undefined,
      attributes: {},
      relationships: {},
      ...data,
    };

    const relations = {};

    // To avoid circular dependency problems, lets set relations only for first 5 depth levels
    if (depth <= 5) {
      Object.keys(data.relationships).forEach((key) => {
        const relation = data.relationships[key];
        if (Array.isArray(relation.data)) {
          relations[key] = relation.data.map((d) => getRecordFromIncluded(d, included, depth + 1));
        } else {
          relations[key] = getRecordFromIncluded(relation.data, included, depth + 1);
        }
      });
    }

    return {
      uuid: data.uuid,
      type: data.type,
      ...data.attributes,
      ...relations,
    };
  }
}



// WEBPACK FOOTER //
// ./src/lib/utils/api/dejsonapinize.js